import { registerBenefitsSx } from '@/components/content/Login/styles/registerBenefits';
import { useLocalization } from '@/data/Localization';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import PaymentIcon from '@mui/icons-material/Payment';
import { Box, Stack, Typography } from '@mui/material';
import { FC } from 'react';

export const RegisterBenefits: FC = () => {
	const labels = useLocalization('SignIn');
	const benefits = [
		{
			icon: <PaymentIcon sx={registerBenefitsSx.icon} />,
			text: labels.Benefits.Payment.t(),
		},
		{
			icon: <ManageSearchIcon sx={registerBenefitsSx.icon} />,
			text: labels.Benefits.Order.t(),
		},
		{
			icon: <FavoriteBorderIcon sx={registerBenefitsSx.icon} />,
			text: labels.Benefits.Favorite.t(),
		},
		{
			icon: <LocalOfferIcon sx={registerBenefitsSx.icon} />,
			text: labels.Benefits.Promotions.t(),
		},
	];

	return (
		<Box sx={registerBenefitsSx.container}>
			{benefits.map((benefit) => (
				<Stack key={benefit.text} direction="row" alignItems="center" spacing={0.625}>
					{benefit.icon}
					<Typography variant="bodySubText" sx={registerBenefitsSx.text}>
						{benefit.text}
					</Typography>
				</Stack>
			))}
		</Box>
	);
};
